module.exports = __webpack_public_path__ + "static/media/pic16.5839111c.jpg";